(() => {
  if (window.njtPartsSliderReady) return;
  window.njtPartsSliderReady = true;
  let animation = 0;
  let coastingTrack = null;
  const scale = () => parseFloat(getComputedStyle(document.body).zoom) || 1;
  const stopMomentum = () => {
    cancelAnimationFrame(animation);
    animation = 0;
    coastingTrack?.classList.remove('njt-is-coasting');
    coastingTrack = null;
  };
  const glide = (track, velocity) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(velocity) < 0.04) return;
    const card = track.querySelector('.njt-popular-card');
    const step = card.getBoundingClientRect().width / scale() + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const start = track.scrollLeft;
    const target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, Math.round((start + velocity * 280) / step) * step));
    const distance = target - start;
    if (Math.abs(distance) < 1) return;
    const duration = Math.min(1100, Math.max(450, Math.abs(distance) / Math.max(Math.abs(velocity), 0.2) * 3));
    const began = performance.now();
    coastingTrack = track;
    track.classList.add('njt-is-coasting');
    const frame = now => {
      if (!track.isConnected || document.hidden) { stopMomentum(); return; }
      const progress = Math.min(1, (now - began) / duration);
      track.scrollLeft = start + distance * (1 - Math.pow(1 - progress, 3));
      if (progress < 1) animation = requestAnimationFrame(frame);
      else stopMomentum();
    };
    animation = requestAnimationFrame(frame);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-njt-parts-slide]');
    if (!button) return;
    stopMomentum();
    const track = document.getElementById(button.getAttribute('aria-controls'));
    const card = track?.querySelector('.njt-popular-card');
    if (!card) return;
    const step = card.getBoundingClientRect().width / scale() + (parseFloat(getComputedStyle(track).columnGap) || 0);
    track.scrollBy({left: Number(button.dataset.njtPartsSlide) * step,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  let drag = null;
  let blockedTrack = null;
  let blockUntil = 0;
  document.addEventListener('mousedown', event => {
    if (event.button !== 0 || !matchMedia('(min-width:750px)').matches) return;
    const track = event.target.closest('.njt-popular-grid');
    if (!track || track.scrollWidth <= track.clientWidth) return;
    stopMomentum();
    blockedTrack = null;
    drag = {track, x:event.clientX, left:track.scrollLeft, moved:false, lastX:event.clientX, lastTime:performance.now(), velocity:0};
  });
  document.addEventListener('mousemove', event => {
    if (!drag) return;
    const distance = (event.clientX - drag.x) / scale();
    if (!drag.moved && Math.abs(distance) < 6) return;
    drag.moved = true;
    drag.track.classList.add('njt-is-dragging');
    event.preventDefault();
    const now = performance.now();
    const elapsed = Math.max(1, now - drag.lastTime);
    const speed = (drag.lastX - event.clientX) / scale() / elapsed;
    drag.velocity = Math.max(-2.5, Math.min(2.5, speed));
    drag.lastX = event.clientX;
    drag.lastTime = now;
    drag.track.scrollLeft = drag.left - distance;
  });
  const finish = (allowGlide = true) => {
    if (!drag) return;
    if (drag.moved) {
      blockedTrack = drag.track;
      blockUntil = Date.now() + 500;
    }
    if (allowGlide && drag.moved && performance.now() - drag.lastTime < 100) glide(drag.track, drag.velocity);
    drag.track.classList.remove('njt-is-dragging');
    drag = null;
  };
  document.addEventListener('mouseup', () => finish());
  window.addEventListener('blur', () => {finish(false); stopMomentum();});
  document.addEventListener('wheel', stopMomentum, {passive:true});
  document.addEventListener('touchstart', stopMomentum, {passive:true});
  document.addEventListener('visibilitychange', () => {if (document.hidden) {finish(false);stopMomentum();}});
  document.addEventListener('dragstart', event => {
    if (drag) event.preventDefault();
  });
  document.addEventListener('click', event => {
    if (blockedTrack && Date.now() < blockUntil && blockedTrack.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      blockedTrack = null;
    }
  }, true);
})();
